import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import Heading from '../../../../../common/Heading';
import { TextInput, RadioGroupInput } from '../../../../../common/FormFields';
import type { RadioGroupOption } from '../../../../../common/FormFields';
import formStyles from '../../../../../styles/forms.module.scss';
import commonStyles from '../../../FacilityData/StepWindFacilityData.module.scss';
import s from './StepImmoChargingData.module.scss';

type ImmoChargingField =
  | 'isResidentialOrCommercial'
  | 'numberOfUnits'
  | 'numberOfGarageObjects'
  | 'numberOfParkingSpaces';

const NAME_PREFIX = 'immoChargingData.';

const RESIDENTIAL_OR_COMMERCIAL_OPTIONS: RadioGroupOption[] = [
  {
    value: 'commercial',
    labelMsg: 'offerWizard.stepImmoChargingData.commercial',
  },
  {
    value: 'residential',
    labelMsg: 'offerWizard.stepImmoChargingData.residential',
  },
];

function StepImmoChargingData() {
  const fieldName = (field: ImmoChargingField) => `${NAME_PREFIX}${field}`;

  return (
    <section className={commonStyles.stepImmoChargingData}>
      <Heading level={2} className={commonStyles.heading}>
        <FormattedMessage id="offerWizard.stepImmoChargingData.title" />
      </Heading>
      <div className={formStyles.formFields}>
        <div className={formStyles.inputWithVerticalSpacing}>
          <Field
            captionMsg="offerWizard.stepImmoChargingData.isResidentialOrCommercial"
            name={fieldName('isResidentialOrCommercial')}
            options={RESIDENTIAL_OR_COMMERCIAL_OPTIONS}
            component={RadioGroupInput}
            radioButtonsWrapperClass={s.radioButtons}
            required
          />
        </div>
        <div className={formStyles.inputPairSingle}>
          <Field
            name={fieldName('numberOfUnits')}
            component={TextInput}
            labelMsg="offerWizard.stepImmoChargingData.numberOfUnits.label"
          />
        </div>
        <div className={formStyles.inputPairSingle}>
          <Field
            name={fieldName('numberOfGarageObjects')}
            component={TextInput}
            labelMsg="offerWizard.stepImmoChargingData.numberOfGarageObjects.label"
          />
        </div>
        <div className={formStyles.inputPairSingle}>
          <Field
            name={fieldName('numberOfParkingSpaces')}
            component={TextInput}
            labelMsg="offerWizard.stepImmoChargingData.numberOfParkingSpaces.label"
          />
        </div>
      </div>
    </section>
  );
}

export default StepImmoChargingData;
